export const Authority = {
  iCARE_Admin: 'iCARE_Admin',
  iCARE_Geschaeftsfuehrung: 'iCARE_Geschaeftsfuehrung',
  iCARE_AD_Team_Antibiose: 'iCARE_AD_Team_Antibiose',
  iCARE_Ernaehrungswissenschaften: 'iCARE_Ernaehrungswissenschaften',
  iCARE_ID_Innendienst: 'iCARE_ID_Innendienst',
  iCARE_AD_Aussendienst: 'iCARE_AD_Aussendienst',
  iCARE_ID_Lager: 'iCARE_ID_Lager',
}

export type AuthorityType = (typeof Authority)[keyof typeof Authority]
